'use strict'

import React from 'react';
import Layout from '../Layout.jsx';
import ProjectMenu from '../components/ProjectMenu.jsx';

import {RegisterProduct} from '../NewProject.jsx';

export class ProductProperties extends React.Component {
  render() {
    return (
      <div>
        <div style={{textAlign: "center", display:"flex", justifyContent:"center"}}>
          <div style={{width:1016}}>
            <RegisterProduct {...this.props} project={this.props.product}/>
          </div>
        </div>
      </div>
    )
  }
}

export default class ProgrammePropertiesPage extends React.Component {
  render() {
    var menu=(this.props.showMenu===true) ? <ProjectMenu {...this.props} project={this.props.product}/> : undefined;
    return (
      <Layout {...this.props} projectMenu={menu} project={this.props.product}>
        <ProductProperties {...this.props}/>
      </Layout>
    );
  }

}



// WEBPACK FOOTER //
// ./views/product/ProductProperties.jsx